import { isRef, onBeforeUnmount, onMounted, unref, watch, type MaybeRef } from 'vue'

export interface HotkeyMatcher {
  code: string
  shift?: boolean
  alt?: boolean
  ctrl?: boolean
}

export function useHotkey(
  targetEl: MaybeRef<HTMLElement | null>,
  matcher: HotkeyMatcher,
  callback: (event: KeyboardEvent) => void
) {
  const isMatching = (event: KeyboardEvent) => {
    if (event.code !== matcher.code) return false
    if (matcher.shift !== undefined && event.shiftKey !== matcher.shift) return false
    if (matcher.alt !== undefined && event.altKey !== matcher.alt) return false
    if (matcher.ctrl !== undefined && event.ctrlKey !== matcher.ctrl) return false
    return true
  }

  const onKeyPress = (event: KeyboardEvent) => {
    if (isMatching(event)) callback(event)
  }

  onMounted(() => {
    const targetElVal = unref(targetEl)
    if (!targetElVal) return

    targetElVal.addEventListener('keypress', onKeyPress)
  })

  if (isRef(targetEl)) {
    watch(targetEl, (targetEl, prevTargetEl) => {
      prevTargetEl?.removeEventListener('keypress', onKeyPress)
      targetEl?.addEventListener('keypress', onKeyPress)
    })
  }

  onBeforeUnmount(() => {
    const targetElVal = unref(targetEl)
    if (!targetElVal) return

    targetElVal.removeEventListener('keydown', onKeyPress)
  })
}
